__turbopack_context__.v({
  "addressText": "wc3rOq_addressText",
  "bodyText": "wc3rOq_bodyText",
  "contactBodyText": "wc3rOq_contactBodyText",
  "contactInfoRow": "wc3rOq_contactInfoRow",
  "contactInfoRows": "wc3rOq_contactInfoRows",
  "header": "wc3rOq_header",
  "infoButton": "wc3rOq_infoButton",
  "left": "wc3rOq_left",
  "orderFormat": "wc3rOq_orderFormat",
  "orderFormatsWrapper": "wc3rOq_orderFormatsWrapper",
  "outletNameText": "wc3rOq_outletNameText",
  "right": "wc3rOq_right",
  "row": "wc3rOq_row",
});
